/* global modForm */
import { heapIdentify, getPhoneAssignmentData, addToHeapEventAndUserProperties, trackPageContextToGA4 } from '../../helpers';

export function transformQuadlinkSuccessCallback(response, options = {}) {
	if (!response) {
		return;
	}

	for (const value in response) {
		if (modForm.opts.qsParams.includes(value) && response.hasOwnProperty(value)) { // eslint-disable-line no-prototype-builtins
			modForm.opts.quadLinkParams[value] = response[value];
		}
	}

	if (modForm.opts.phoneAssignmentConfig.showPhoneAssignmentNumber && !options.skipPhoneAssignmentCall) {
		getPhoneAssignmentData(response);
	}

	heapIdentify();
	modForm.opts.quadLinkHasBeenTransformed = true;
	addToHeapEventAndUserProperties([
		modForm.opts.quadLinkParams,
		{ 'AffiliateKey': response.AffiliateKey }
	]);
	trackPageContextToGA4();
}
